module.exports = __webpack_public_path__ + "static/img/Circle.8c36ea4e.png";